import { HttpClient } from "@angular/common/http";
import {
  AfterContentChecked,
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import {MatDialog as MatDialog } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "src/app/services/auth.service";
import { BlockSettingsComponent } from "../block-settings/block-settings.component";
import { SecurityPopUpComponent } from "../security-pop-up/security-pop-up.component";
import { BehaviorSubject, debounce, debounceTime, of } from "rxjs";
import { JsonHandlerService } from "../services/json-handler.service";
import { AlertService } from "../services/alert.service";
import { CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
import { TheUserSubscrbtionSearch } from "src/app/users-management/models/data-models";
import {isEqual} from "lodash";
@Component({ 
  // changeDetection: ChangeDetectionStrategy.OnPush,

  selector: "app-component-positioning",
  templateUrl: "./component-positioning.component.html",
  styleUrls: ["./component-positioning.component.css"],
})
export class ComponentPositioningComponent
  implements OnInit, AfterContentChecked
{
  theme: any;
  constructor(
    private alertService: AlertService,
    private jsonHandler: JsonHandlerService,
    private cdr: ChangeDetectorRef,
    private httpClient: HttpClient,
    private dialog: MatDialog,
     private snotifyService: ToastrService,
    private authService: AuthService
  ) {
    
    this.cdr.detach();
  }
  paginatedCards: any[] = []; 
  currentPage: number = 0; 
  pageSize: number = 4; 
  @Input() page: any;
  @Input() selectedVersion: any;

  @Input() pageLayout: any;
  @Input() viewSize: any;
  @Input() editLayout: any;
  @Input() isTemplate: any;
  @Output() viewSetting = new EventEmitter<any>();
  @Output() IDsForConnect = new EventEmitter<any>();
levelOne=0;
levelTwo=0;
levelThree=0;
levelFour=0;
  searchTerm=""
  getCurrenttarget: any = 0;
  selectedComponent: any;
  settingOpened: boolean = false;
selectedBlock: any = { element: {} };
  rolesList = null;
  tempComponent;
  dialogRef: any;
  cards=[]
  rolesAndAsigend: any;
  ngOnInit() {
    this.getTheme();
  }

  getTheme() {
    this.httpClient.get("/Themes/GetThemes").subscribe((res: any) => {
      this.theme = res;
    });
  }
getTemplates(col,isRow?){
  let data={
    pagination: {
      start: 0,
      number: 50,
    },
    search: {
     
      name: isRow?"":col.component.componentName,
      description: this.searchTerm,
  
      settingsType: isRow?"ROW":"COMPONENT",
      thumbnailUrl: "",
      settings: "",
      fullSearch:""
    },
  }
this.httpClient.post("/PredefinedTemplates/GetAllSettings",data).pipe(debounceTime(500)).subscribe((res:any)=>{
  this.cards=res.data
  this.updatePaginatedCards()
})
}
updatePaginatedCards() {
  const startIndex = this.currentPage * this.pageSize;
  const endIndex = startIndex + this.pageSize;
  this.paginatedCards = this.cards.slice(startIndex, endIndex);
}

nextPage() {
  if ((this.currentPage + 1) * this.pageSize < this.cards.length) {
    this.currentPage++;
    this.updatePaginatedCards();
  }
}

previousPage() {
  if (this.currentPage > 0) {
    this.currentPage--;
    this.updatePaginatedCards();
  }
}
  getViewCols(block) {
    if (this.viewSize != "Default") {
      if (block.sizes) {
        return block.sizes[this.viewSize]
          ? block.sizes[this.viewSize]
          : block.size;
      } else return block.size ? "-" + block.size : "";
    } else return block.size ? "-" + block.size : "";
  }
  openPopup(PopupComponent,i,ii,iii,iiii,col,isRow?) {
    this.tempComponent=isRow?'Row':col
    this.levelOne=i,this.levelTwo=ii,this.levelThree=iii;this.levelFour=iiii
    this.dialog.open(PopupComponent, {
      width: '80%',
      hasBackdrop: true,
      backdropClass: 'custom-backdrop',
    });
    this.getTemplates(col,isRow)
  }
  closeDialog() {
  
    this.dialog.closeAll();
  }

  dropContainer(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);   
  
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
      this.pageLayout.containers.push({   
   type: 'full', rows: [],published: true }); 
    }
  }
  // dropOnContainer(c, dragData, index) {
  //    //   if (dragData.type == "container") {
  //     dragData.source[index] = JSON.parse(JSON.stringify(dragData.data));
  //     dragData.source[dragData.pos] = JSON.parse(JSON.stringify(c));
  //   } else {
  //     dragData.source.splice(dragData.pos, 1);
  //     c.rows.push(JSON.parse(JSON.stringify(dragData.data)));
  //   }
  // }

  // dropOnRow(rows, dragData, index) {
  //    //   // col on row
  //   if (dragData.type == "col" || dragData.type == "subColContainer") {
  //     var temp = dragData.source.splice(dragData.pos, 1);
  //     rows[index].cols.push(JSON.parse(JSON.stringify(temp[0])));
  //     return rows;
  //   }

  //   // subCol on row
  //   if (dragData.type == "subCol") {
  //     rows[index].cols.push(
  //       JSON.parse(JSON.stringify(dragData.source[dragData.pos]))
  //     );
  //     this.deleteSplitedCol(
  //       dragData.source[dragData.pos],
  //       dragData.subColumns,
  //       dragData.pos
  //     );
  //     return rows;
  //   }

  //   // newCol on row
  //   if (dragData.type == "newCol") {
  //     rows[index].cols.push(JSON.parse(JSON.stringify(dragData.data)));
  //     return rows;
  //   }

  //   // row on row
  //   if (dragData.type == "row") {
  //     dragData.source[dragData.pos] = JSON.parse(JSON.stringify(rows[index]));
  //     rows[index] = JSON.parse(JSON.stringify(dragData.data));
  //     return rows;
  //   }

  //   return rows;
  // }

  // dropOnColumn(cols, dragData, colIndex, isDrobedOnSubCol) {
  //    //   var newragData = JSON.parse(JSON.stringify(dragData.data));

  //   if (dragData.identifierCode) {
  //     Object.assign(newragData, {
  //       setting: dragData.identifierCode,
  //       sharedSettings: true,
  //     });
  //   }
  //   // new Col on Col
  //   if (dragData.type == "newCol") {
  //     cols.splice(colIndex + 1, 0, newragData);
  //     return cols;
  //   }

  //   // component on col or subCol
  //   if (dragData.type == "component") {
  //     newragData.componentSettingsId =         Math.random().toString(36).substr(2, 9) + new Date().getTime();
  
  //     if (isDrobedOnSubCol) {
  //       if (cols[colIndex].component && cols[colIndex].component.name) {
  //         cols.push({ size: 12, published: true, component: newragData });
  //       } else {
  //         cols[colIndex].component = newragData;
  //         // cols[colIndex].component.componentSettingsId= v4()
  //       }
  //     } else {
  //       if (cols[colIndex].subCols) {
  //         cols[colIndex].subCols.push({
  //           size: 12,
  //           published: true,
  //           component: newragData,
  //         });
  //       } else if (cols[colIndex].component && cols[colIndex].component.name) {
  //         cols[colIndex] = this.splitColumn(cols[colIndex], true);

  //         //by sondos
  //         //var temp = JSON.parse(JSON.stringify(cols[colIndex]));
  //         var temp:any = {};

  //         temp.component = newragData;
  //         temp.size = 12;
  //         temp.published = true;
  //         cols[colIndex].subCols.push(temp);
  //       } else {
  //         cols[colIndex].component = newragData;
  //       }
  //     }
  //     // if(!cols[colIndex].component)
  //     // cols[colIndex].component={}
  //     // cols[colIndex].component.componentSettingsId= v4()
  //     return cols;
  //   }

  //   // col on col  or subCol on subCol or subCol on col
  //   if (
  //     (!isDrobedOnSubCol && dragData.type == "col") ||
  //     (isDrobedOnSubCol && dragData.type == "col") ||
  //     (isDrobedOnSubCol && dragData.type == "subCol") ||
  //     (isDrobedOnSubCol && dragData.type == "subCol") ||
  //     (!isDrobedOnSubCol && dragData.type == "subColContainer")
  //   ) {
  //     dragData.source[dragData.pos] = JSON.parse(
  //       JSON.stringify(cols[colIndex])
  //     );
  //     cols[colIndex] = newragData;
  //     return cols;
  //   }

  //   if (!isDrobedOnSubCol && dragData.type == "subCol") {
  //     if (cols[colIndex].subCols && cols[colIndex].subCols.length) {
  //       cols[colIndex].subCols.push(newragData);
  //       this.deleteSplitedCol(
  //         dragData.source[dragData.pos],
  //         dragData.subColumns,
  //         dragData.pos
  //       );
  //     } else {
  //       cols[colIndex] = this.splitColumn(cols[colIndex], true);
  //       var temp = JSON.parse(JSON.stringify(cols[colIndex]));
  //       // temp.component = JSON.parse(JSON.stringify(dragData.data))
  //       temp.size = 12;
  //       cols[colIndex].subCols.push(dragData.data);
  //       this.deleteSplitedCol(
  //         dragData.source[dragData.pos],
  //         dragData.subColumns,
  //         dragData.pos
  //       );
  //     }
  //   }

  //   return cols;
  // }
  dropOnContainer(c, dragData, index) {
       if (dragData.item.data.type === "container") {
      // dragData.source[index] = { ...dragData.item.data.data };
      // dragData.source[dragData.previousIndex] = { ...c };
    } else {
     // dragData.container.data.splice(dragData.previousIndex, 1);
     // c.rows[index].cols.push({size: 12, published: true, component:dragData.item.data.data });
      this.dropOnRow(dragData,index)
    }
  }

  dropOnEmpty(dragData,mainIndex,subIndex){



console.log(dragData,mainIndex,subIndex)
  }
  
  dropOnRow(dragData , container=0) {
       if(dragData.item.data.type === "component"){
      
      dragData.container.data[dragData.container.data.length-1].cols.push({size: 12, published: true,component:{...dragData.item.data.data,setting:dragData.item.data.data.setting &&Object.keys(dragData.item.data.data).length? dragData.item.data.data:{}} });
    }
    if (dragData.item.data.type === "col" || dragData.item.data.type === "subColContainer") {
      moveItemInArray(dragData.item.data.source,dragData.previousIndex,dragData.currentIndex)

    }
  
    if (dragData.item.data.type === "subCol") {
      moveItemInArray(dragData.item.data.source,dragData.previousIndex,dragData.currentIndex)

    }
  
    if (dragData.item.data.type === "newCol") {
      dragData.container.data[dragData.container.data.length-1].cols.push({size: 12, published: true, component:{...dragData.item.data.data,setting:dragData.item.data.data.setting &&Object.keys(dragData.item.data.data).length? dragData.item.data.data:{}} });

      
    }
  
    if (dragData.item.data.type === "row") {
      if(dragData.container == dragData.previousContainer){
        moveItemInArray(dragData.item.data.source,dragData.previousIndex,dragData.currentIndex)
        // dragData.item.data.source[dragData.item.data.pos] = { ...cols };
        }else{
          transferArrayItem(
            dragData.previousContainer.data,
            dragData.container.data,
            dragData.previousIndex,
            dragData.currentIndex,
          );
    
        }
        
    }
  
 
  }
  

   deepEqual(objA: any, objB: any): boolean {
    if (objA === objB) return true;
  
    if (typeof objA !== 'object' || typeof objB !== 'object' || objA === null || objB === null) {
      return false;
    }
  
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
  
    if (keysA.length !== keysB.length) {
      return false;
    }
  
    return keysA.every(key => this.deepEqual(objA[key], objB[key]));
  }
  
  

  

  dropOnColumn(dragData ,containerPostion=0,rowPosition,ColumnPosition,type,subColumn) {
    const newragData = { ...dragData.item.data };
  
    if (dragData.item.data.identifierCode) {
      Object.assign(newragData, {
        setting: dragData.item.data.identifierCode,
        sharedSettings: true
      });
    }
  
    // if (dragData.item.data.type === "newCol") {
    //   cols.splice(colIndex + 1, 0, newragData);
    //   return cols;
    // }
  
    // if (dragData.item.data.type === "component") {
    //   newragData.componentSettingsId = Math.random().toString(36).substr(2, 9) + new Date().getTime();
  
    //   if (isDrobedOnSubCol) {
    //     if (cols[colIndex].component && cols[colIndex].component.name) {
    //       cols.push({ size: 12, published: true, component: newragData });
    //     } else {
    //       cols[colIndex].component = newragData;
    //     }
    //   } else {
    //     if (cols[colIndex].subCols) {
    //       cols[colIndex].subCols.push({ size: 12, published: true, component: newragData });
    //     } else if (cols[colIndex].component && cols[colIndex].component.name) {
    //       cols[colIndex] = this.splitColumn(cols[colIndex], true);
    //       const temp = { component: newragData, size: 12, published: true };
    //       cols[colIndex].subCols.push(temp);
    //     } else {
    //       cols[colIndex].component = newragData;
    //     }
    //   }
  
    //   return cols;
    // }
  


       if(dragData.item.data.type === "component"){
      let isEmpty=-1

      
        // for(let i=0 ; i<=dragData.container.data.length-1;i++){
        //   for(let k=0; k<= dragData.container.data[i].cols; k++){

        //     if(Object.keys(dragData.container.data[i].cols[k].component).length == 0){
        //       dragData.container.data[i].component= dragData.item.data.data ;
        //     break
            
        //     }
        //   }
         
        // }
        try{}
        catch{}
if(type == 'intoEmpty' && dragData.container.data.col.component && Object.keys(dragData.container.data.col.component).length == 0){
  dragData.container.data.col.component= {...dragData.item.data.data,setting:dragData.item.data.data.setting &&Object.keys(dragData.item.data.data.setting).length? dragData.item.data.data.setting:dragData.item.data.identifierCode?dragData.item.data.identifierCode:{}} 
}
     else{
      if(dragData.container.data.col.subCols){
        dragData.container.data.cols[ColumnPosition].subCols.push({size: 12, published: true,component:{...dragData.item.data.data,setting:dragData.item.data.data.setting &&Object.keys(dragData.item.data.data).length? dragData.item.data.data:{}} });

      }else{
        dragData.container.data.cols.push({size: 12, published: true, component:{...dragData.item.data.data,setting:dragData.item.data.data.setting &&Object.keys(dragData.item.data.data.setting).length? dragData.item.data.data.setting:dragData.item.data.identifierCode?dragData.item.data.identifierCode:{}} });

      }

     }
    }
    // if (dragData.item.data.type === "col" || dragData.item.data.type === "subColContainer") {
    //   moveItemInArray(dragData.item.data.source,dragData.previousIndex,dragData.currentIndex)

    // }
  
    if (dragData.item.data.type === "subCol") {
      if(dragData.item.data.containerPosition == containerPostion && dragData.item.data.rowPosition == rowPosition){
        moveItemInArray(dragData.item.data.source,dragData.item.data.dragedIndex,subColumn)
        // dragData.item.data.source[dragData.item.data.pos] = { ...cols };
        }else{
          transferArrayItem(
            dragData.previousContainer.data.cols,
            dragData.container.data.cols,
            dragData.item.data.dragedIndex,
            subColumn,
          );
    
        }

      // moveItemInArray(dragData.item.data.source,dragData.previousIndex,dragData.currentIndex)

    }
  
    if (dragData.item.data.type === "newCol") {
      dragData.container.data[dragData.container.data.length-1].cols.push({size: 12, published: true, component:{...dragData.item.data.data,setting:dragData.item.data.data.setting &&Object.keys(dragData.item.data.data.setting).length? dragData.item.data.data.setting:dragData.item.data.identifierCode?dragData.item.data.identifierCode:{}} });

      
    }
  
    if (dragData.item.data.type === "row") {
      if(dragData.container == dragData.previousContainer){
        moveItemInArray(dragData.item.data.source,dragData.previousIndex,dragData.currentIndex)
        // dragData.item.data.source[dragData.item.data.pos] = { ...cols };
        }else{
          transferArrayItem(
            dragData.previousContainer.data,
            dragData.container.data,
            dragData.previousIndex,
            dragData.currentIndex,
          );
    
        }
        
    }
  


    if (
      (dragData.item.data.type === "col") ||
      (dragData.item.data.type === "col")  ||(dragData.item.data.type === "subColContainer" )
      
    ) {
      
      if(dragData.item.data.containerPosition == containerPostion && dragData.item.data.rowPosition == rowPosition){
      moveItemInArray(dragData.item.data.source,dragData.item.data.columnPostion,ColumnPosition)
      // dragData.item.data.source[dragData.item.data.pos] = { ...cols };
      }else{
        transferArrayItem(
          dragData.previousContainer.data.cols,
          dragData.container.data.cols,
          dragData.item.data.columnPostion,
          ColumnPosition,
        );
  
      }
      
    }

//     if( dragData.item.data.type === "subColContainer" || dragData.previousIndex == dragData.currentIndex){
// this.pageLayout.containers[mainIndex].rows[0].cols.push(dragData.item.data.data)
// dragData.item.data.source.splice(dragData.item.data.pos,1)

//     }
  
    // if (!isDrobedOnSubCol && dragData.item.data.type === "subCol") {
    //   if (cols[colIndex].subCols && cols[colIndex].subCols.length) {
    //     cols[colIndex].subCols.push(newragData);
    //     this.deleteSplitedCol(dragData.item.data.source[dragData.item.data.pos], dragData.item.data.subColumns, dragData.item.data.pos);
    //   } else {
    //     cols[colIndex] = this.splitColumn(cols[colIndex], true);
    //     const temp = { size: 12, subCols: [dragData.item.data] };
    //     cols[colIndex].subCols.push(temp);
    //     this.deleteSplitedCol(dragData.item.data.source[dragData.item.data.pos], dragData.item.data.subColumns, dragData.item.data.pos);
    //   }
    // }
  
    // return cols;
  }

IDs=[]
IDsForRow=[]
IDsForSubCol=[]
IDsForContainer=[]
  pushIds(id , type){
  if(type == 'Column'){
    this.IDs.push(id)
    return this.IDs
  }else if(type == "subCol"){
    this.IDsForSubCol.push(id)
    return this.IDsForSubCol
  }
  else if(type == "Container"){
    this.IDsForContainer.push(id)
    return this.IDsForContainer
  }
  
  else{this.IDsForRow.push(id)
    return this.IDsForRow}

   


  }
AllIDs=[]
  linkIDsWithParentComponent(data,type){
if(data && !this.AllIDs.includes(data)){
this.AllIDs.push(data)
this.IDsForConnect.emit(this.AllIDs)
this.cdr.detectChanges()

return data
}
return data
   
  }
  splitColumn(col, DoNotAddEmptyCol?) {
    var temp = JSON.parse(JSON.stringify(col));
    col.component = undefined;
    col.subCols = [];
    temp.size = 12;
    col.subCols.push(temp);
    if (!DoNotAddEmptyCol) {
      col.subCols.push({ size: 12, component: {}, published: true });
    }
    return col;
  }
replaceJson(newData,isRow){
if(newData==""){
  this.closeDialog()
  return;
}
if(isRow){
  this.pageLayout.containers[this.levelOne]=JSON.parse(newData)
}
else if(this.levelFour != undefined){
  this.pageLayout.containers[this.levelOne].rows[this.levelTwo].cols[this.levelThree].subCols[this.levelFour]=JSON.parse(newData)

}else{
    this.pageLayout.containers[this.levelOne].rows[this.levelTwo].cols[this.levelThree]=JSON.parse(newData)
}
// col=newCol
this.closeDialog()
}
  openRowSettings(b, index) {
    const dialogRef = this.dialog.open(BlockSettingsComponent, {
      data: {
        block: b,
        theme: this.theme,
        type: "row",
        index: index,
        from: "page",
      },
      width: "0vh",
      position: { right: "0" },
    });
    this.cdr.detectChanges();
  }

  openContainerSettings(b, index) {
    const dialogRef = this.dialog.open(BlockSettingsComponent, {
      data: {
        block: b,
        theme: this.theme,
        type: "container",
        index: index,
        from: "page",
      },
      width: "0vh",
      position: { right: "0" },
    });
    this.cdr.detectChanges();
  }
  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }
  downloadJsonFile(data: any, filename: string,data2?): void {
    console.log(data2)
    const jsonString = JSON.stringify(data, null, 2); // Format JSON with indentation
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url); // Free up memory
  }
  
  openColSettings(b, index) {
    const dialogRef = this.dialog.open(BlockSettingsComponent, {
      data: {
        block: b,
        theme: this.theme,
        type: "col",
        index: index,
        from: "page",
      },
      width: "0vh",
      position: { right: "0" },
    });
  }
 updateSecurityforContainer(c) {
   
    if (c ) {
      this.httpClient
        .get("/RolesManagement/GetRoles")
        .subscribe((res: any[]) => {
          if (!c.hasOwnProperty("rolesAndAsigend")) {
            this.dialogRef = this.dialog.open(SecurityPopUpComponent, {
              width: "70vw",
              height: "80vh",
              data: {
                unassigendRole: res,
                assigendRoles: [],
                isComponent: c.component ? true : false,
              },
            });
          } else {
            this.dialogRef = this.dialog.open(SecurityPopUpComponent, {
              width: "70vw",
              height: "80vh",
              data: {
                unassigendRole: res.filter(
                  (r) => !c.rolesAndAsigend.includes(r.id)
                ),
                assigendRoles: res.filter((r) =>
                  c.rolesAndAsigend.includes(r.id)
                ),
            
                isComponent: c.component ? true : false,
              },
            });
          }
          this.dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.rolesAndAsigend = {
                unassigendRole: result.unassigendRole,
                assingedRoles: result.assigendRoles,
              };
              let roles: any[] = result.assigendRoles.map((el) => {
                return el.id;
              });
              if(roles.length == 0){
              delete c.rolesAndAsigend
                return;
              }else{
              c.rolesAndAsigend = roles;

              }
           
            }
          });
        });
    }
  }
  updateSecurityforrow(row) {
   
    if (row ) {
      this.httpClient
        .get("/RolesManagement/GetRoles")
        .subscribe((res: any[]) => {
          if (!row.hasOwnProperty("rolesAndAsigend")) {
            this.dialogRef = this.dialog.open(SecurityPopUpComponent, {
              width: "70vw",
              height: "80vh",
              data: {
                unassigendRole: res,
                assigendRoles: [],
                isComponent: row.component ? true : false,
              },
            });
          } else {
            this.dialogRef = this.dialog.open(SecurityPopUpComponent, {
              width: "70vw",
              height: "80vh",
              data: {
                unassigendRole: res.filter(
                  (r) => !row.rolesAndAsigend.includes(r.id)
                ),
                assigendRoles: res.filter((r) =>
                  row.rolesAndAsigend.includes(r.id)
                ),
            
                isComponent: row.component ? true : false,
              },
            });
          }
          this.dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.rolesAndAsigend = {
                unassigendRole: result.unassigendRole,
                assingedRoles: result.assigendRoles,
              };
              let roles: any[] = result.assigendRoles.map((el) => {
                return el.id;
              });
               if(roles.length == 0){
              delete row.rolesAndAsigend
                return;
              }else{
              row.rolesAndAsigend = roles;

              }
            
           
            }
          });
        });
    }
  }

  updateSecurityforcol(col, index) {
   
    if (col && index) {
      this.httpClient
        .get("/RolesManagement/GetRoles")
        .subscribe((res: any[]) => {
          if (!col.hasOwnProperty("rolesAndAsigend")) {
            this.dialogRef = this.dialog.open(SecurityPopUpComponent, {
              width: "70vw",
              height: "80vh",
              data: {
                unassigendRole: res,
                assigendRoles: [],
                isComponent: col.component ? true : false,
               
              },
            });
          } else {
            this.dialogRef = this.dialog.open(SecurityPopUpComponent, {
              width: "70vw",
              height: "80vh",
              data: {
                unassigendRole: res.filter(
                  (r) => !col.rolesAndAsigend.includes(r.id)
                ),
                assigendRoles: res.filter((r) =>
                  col.rolesAndAsigend.includes(r.id)
                ),
         
                isComponent: col.component ? true : false,
              },
            });
          }
          this.dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.rolesAndAsigend = {
                unassigendRole: result.unassigendRole,
                assingedRoles: result.assigendRoles,
              };
              let roles: any[] = result.assigendRoles.map((el) => {
                return el.id;
              });
              
     if(roles.length == 0){
              delete col.rolesAndAsigend
                return;
              }else{
             col.rolesAndAsigend = roles;

              }
            }
          });
        });
    }
  }

  updateSecurityforsubcol(col, index) {
   
    if (col && index) {
      this.httpClient
        .get("/RolesManagement/GetRoles")
        .subscribe((res: any[]) => {
          if (!col.component.hasOwnProperty("rolesAndAsigend")) {
            this.dialogRef = this.dialog.open(SecurityPopUpComponent, {
              width: "70vw",
              height: "80vh",
              data: {
                unassigendRole: res,
                assigendRoles: [],
        
                isComponent: col.component ? true : false,
              },
            });
          } else {
            this.dialogRef = this.dialog.open(SecurityPopUpComponent, {
              width: "70vw",
              height: "80vh",
              data: {
                unassigendRole: res.filter(
                  (r) => !col.component.rolesAndAsigend.includes(r.id)
                ),
                assigendRoles: res.filter((r) =>
                  col.component.rolesAndAsigend.includes(r.id)
                ),
              
                isComponent: col.component ? true : false,
              },
            });
          }
          this.dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.rolesAndAsigend = {
                unassigendRole: result.unassigendRole,
                assingedRoles: result.assigendRoles,
              };
              let roles: any[] = result.assigendRoles.map((el) => {
                return el.id;
              });
             
              if(roles.length == 0){
              delete col.component.rolesAndAsigend 
                return;
              }else{
              col.component.rolesAndAsigend = roles;

              }
            }
          });
        });
    }
  }
  updateSecurity(col, index) {
   
    if (col && index) {
      this.httpClient
        .get("/RolesManagement/GetRoles")
        .subscribe((res: any[]) => {
          if (!col.component.hasOwnProperty("rolesAndAsigend")) {
            this.dialogRef = this.dialog.open(SecurityPopUpComponent, {
              width: "70vw",
              height: "80vh",
              data: {
                unassigendRole: res,
                assigendRoles: [],
          
                isComponent: col.component ? true : false,
              },
            });
          } else {
            this.dialogRef = this.dialog.open(SecurityPopUpComponent, {
              width: "70vw",
              height: "80vh",
              data: {
                unassigendRole: res.filter(
                  (r) => !col.component.rolesAndAsigend.includes(r.id)
                ),
                assigendRoles: res.filter((r) =>
                  col.component.rolesAndAsigend.includes(r.id)
                ),
            
                isComponent: col.component ? true : false,
              },
            });
          }
          this.dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.rolesAndAsigend = {
                unassigendRole: result.unassigendRole,
                assingedRoles: result.assigendRoles,
              };
              let roles: any[] = result.assigendRoles.map((el) => {
                return el.id;
              });
             
         
              if(roles.length == 0){
              delete col.component.rolesAndAsigend 
                return;
              }else{
              col.component.rolesAndAsigend = roles;

              }
            }
          });
        });
    }
  }

  deleteSplitedCol(subCol, col, i) {
    if (col.subCols && col.subCols.length > 1) {
      if (col.subCols && col.subCols.length == 2) {
        col.component = col.subCols[0].component
          ? JSON.parse(JSON.stringify(col.subCols[0].component))
          : {};
        //col.subCols = undefined;
        col.subCols.splice(i, 1);
        if (col.subCols.length == 1) {
          col.component = col.subCols[0].component
            ? JSON.parse(JSON.stringify(col.subCols[0].component))
            : {};
          col.subCols = undefined;
        }
      } else col.subCols.splice(i, 1);
    } else {
      col.component = col.subCols[0].component
        ? JSON.parse(JSON.stringify(col.subCols[0].component))
        : {};
      col.subCols = undefined;
    }
  }

  openSetting(col, comp, event?) {
    // if (this.isTemplate)
    //   this.openTemplateSetting(col, comp, event, this.page.type != 1 && col.InnerPage)
    // else
    this.viewSetting.emit({ col: col, comp: comp, event: event });
  }

  openTemplateSetting(col, comp, event, isBlog?) {
    if (comp && comp.name) {
      if (isBlog) {
        comp.name = "Blog Details";
        (comp.componentName = "BlogDetailsComponent"),
          (comp.setting = comp.setting || {});
      }
    } else if (isBlog) {
      comp = {};
      comp.name = "Blog Details";
      (comp.componentName = "BlogDetailsComponent"),
        (comp.setting = comp.setting || {});
    }

    this.viewSetting.emit({ col: col, comp: comp, event: event });
  }

  checkIfNew(containerIndex, rowIndex, colIndex, component): boolean {
    var currentLayout =
      this.pageLayout.containers[containerIndex].rows[rowIndex].cols[colIndex];
    var selectedLayout =
      this.selectedVersion.settingsBody.containers[containerIndex].rows[
        rowIndex
      ].cols[colIndex];
    if (JSON.stringify(currentLayout) != JSON.stringify(selectedLayout)) {
      return true;
    } else return false;
  }

  isContainerExists(version, containerIndex: number) {
    if (
      version &&
      version.settingsBody.containers &&
      version.settingsBody.containers.length &&
      version.settingsBody.containers[containerIndex]
    )
      return true;
    else return false;
  }
  isRowExists(version, containerIndex: number, rowIndex: number) {
    if (
      version.settingsBody.containers[containerIndex].rows &&
      version.settingsBody.containers[containerIndex].rows.length &&
      version.settingsBody.containers[containerIndex].rows[rowIndex]
    )
      return true;
    else return false;
  }
  isColExists(
    version,
    containerIndex: number,
    rowIndex: number,
    colIndex: number
  ) {
    if (
      version.settingsBody.containers[containerIndex].rows[rowIndex].cols &&
      version.settingsBody.containers[containerIndex].rows[rowIndex].cols
        .length &&
      version.settingsBody.containers[containerIndex].rows[rowIndex].cols[
        colIndex
      ]
    )
      return true;
    else return false;
  }
  isSubcolExists(
    version,
    containerIndex,
    rowIndex: number,
    colIndex: number,
    subcolIndex: number
  ) {
    if (
      version.settingsBody.containers[containerIndex].rows[rowIndex].cols[
        colIndex
      ].subCols &&
      version.settingsBody.containers[containerIndex].rows[rowIndex].cols[
        colIndex
      ].subCols.length &&
      version.settingsBody.containers[containerIndex].rows[rowIndex].cols[
        colIndex
      ].subCols[subcolIndex]
    )
      return true;
    else return false;
  }
  checkContainerUpdates(containerIndex: number) {
    if (!this.isContainerExists(this.selectedVersion, containerIndex)) {
      return true;
    } else {
      var currentLayout = this.pageLayout.containers[containerIndex];
      var selectedLayout =
        this.selectedVersion.settingsBody.containers[containerIndex];
      currentLayout = this.jsonHandler.isJSONParsable(
        JSON.stringify(currentLayout),
        "container",
        "current"
      );
      selectedLayout = this.jsonHandler.isJSONParsable(
        JSON.stringify(selectedLayout),
        "container",
        "selected"
      );
      if (currentLayout && selectedLayout) {
        delete currentLayout.rows;
        delete selectedLayout.rows;
        var result =
          JSON.stringify(currentLayout) != JSON.stringify(selectedLayout)
            ? true
            : false;
        return result;
      } else return false;
    }
  }
  checkRowUpdates(containerIndex: number, rowIndex: number) {
    if (
      !this.isContainerExists(this.selectedVersion, containerIndex) ||
      !this.isRowExists(this.selectedVersion, containerIndex, rowIndex)
    )
      return true;
    var currentLayout =
      this.pageLayout.containers[containerIndex].rows[rowIndex];
    var selectedLayout =
      this.selectedVersion.settingsBody.containers[containerIndex].rows[
        rowIndex
      ];
    currentLayout = this.jsonHandler.isJSONParsable(
      JSON.stringify(currentLayout),
      "row",
      "current"
    );
    selectedLayout = this.jsonHandler.isJSONParsable(
      JSON.stringify(selectedLayout),
      "row",
      "selected"
    );
    if (currentLayout && selectedLayout) {
      delete currentLayout.cols;
      delete selectedLayout.cols;
      var result =
        JSON.stringify(currentLayout) != JSON.stringify(selectedLayout)
          ? true
          : false;
      return result;
    } else return false;
  }
  checkColumnsUpdates(
    containerIndex: number,
    rowIndex: number,
    colIndex: number
  ) {
    if (
      !this.isContainerExists(this.selectedVersion, containerIndex) ||
      !this.isRowExists(this.selectedVersion, containerIndex, rowIndex) ||
      !this.isColExists(
        this.selectedVersion,
        containerIndex,
        rowIndex,
        colIndex
      )
    )
      return true;
    else {
      var currentLayout =
        this.pageLayout.containers[containerIndex].rows[rowIndex].cols[
          colIndex
        ];
      var selectedLayout =
        this.selectedVersion.settingsBody.containers[containerIndex].rows[
          rowIndex
        ].cols[colIndex];
      currentLayout = this.jsonHandler.isJSONParsable(
        JSON.stringify(currentLayout),
        "columns",
        "current"
      );
      selectedLayout = this.jsonHandler.isJSONParsable(
        JSON.stringify(selectedLayout),
        "columns",
        "selected"
      );
      if (currentLayout && selectedLayout) {
        delete currentLayout.subCols;
        delete selectedLayout.subCols;
        var result =
          JSON.stringify(currentLayout) != JSON.stringify(selectedLayout)
            ? true
            : false;
        return result;
      } else return false;
    }
  }
  checkSubColumnsUpdates(
    containerIndex: number,
    rowIndex: number,
    colIndex: number,
    subColIndex: number
  ) {
    if (
      !this.isContainerExists(this.selectedVersion, containerIndex) ||
      !this.isRowExists(this.selectedVersion, containerIndex, rowIndex) ||
      !this.isColExists(
        this.selectedVersion,
        containerIndex,
        rowIndex,
        colIndex
      ) ||
      !this.isSubcolExists(
        this.selectedVersion,
        containerIndex,
        rowIndex,
        colIndex,
        subColIndex
      )
    )
      return true;
    else {
      var currentLayout =
        this.pageLayout.containers[containerIndex].rows[rowIndex].cols[colIndex]
          .subCols[subColIndex];
      var selectedLayout =
        this.selectedVersion.settingsBody.containers[containerIndex].rows[
          rowIndex
        ].cols[colIndex].subCols[subColIndex];
      currentLayout = this.jsonHandler.isJSONParsable(
        JSON.stringify(currentLayout),
        "sub columns",
        "current"
      );
      selectedLayout = this.jsonHandler.isJSONParsable(
        JSON.stringify(selectedLayout),
        "sub columns",
        "selected"
      );
      if (currentLayout && selectedLayout) {
        delete currentLayout.subCols;
        delete selectedLayout.subCols;
        var result =
          JSON.stringify(currentLayout) != JSON.stringify(selectedLayout)
            ? true
            : false;
        return result;
      } else return false;
    }
  }
}
